/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { League } from '../models/League';
import type { LeagueCategoryDecisionResponse } from '../models/LeagueCategoryDecisionResponse';
import type { MatchLnd } from '../models/MatchLnd';
import type { TeamCreate } from '../models/TeamCreate';
import type { TeamSmallLnd } from '../models/TeamSmallLnd';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class LndService {
    /**
     * Get Lnd Leagues
     * @param comitato
     * @param subCategoryIds
     * @returns League Successful Response
     * @throws ApiError
     */
    public static getLndLeaguesLndLeaguesGet(
        comitato?: (number | null),
        subCategoryIds?: (Array<number> | null),
    ): CancelablePromise<Array<League>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/leagues',
            query: {
                'comitato': comitato,
                'sub_category_ids': subCategoryIds,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Lnd League Ids
     * @param subCategoryIds
     * @param activeOnly
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getLndLeagueIdsLndLeagueIdsGet(
        subCategoryIds?: (Array<number> | null),
        activeOnly: boolean = true,
    ): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/league_ids',
            query: {
                'sub_category_ids': subCategoryIds,
                'active_only': activeOnly,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get League By Comitato And Lnd Short And District
     * @param divisionId
     * @param lndShort
     * @param district
     * @returns any Successful Response
     * @throws ApiError
     */
    public static getLeagueByComitatoAndLndShortAndDistrictLndLeagueDivisionIdLndShortDistrictGet(
        divisionId: number,
        lndShort: string,
        district: string,
    ): CancelablePromise<(League | null)> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/league/{division_id}/{lnd_short}/{district}',
            path: {
                'division_id': divisionId,
                'lnd_short': lndShort,
                'district': district,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Main League Ids Of Team
     * @param teamId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getMainLeagueIdsOfTeamLndMainLeagueIdsOfTeamTeamIdGet(
        teamId: number,
    ): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/main_league_ids_of_team/{team_id}',
            path: {
                'team_id': teamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Team Id By Lnd
     * @param lndId
     * @param leagueId
     * @returns TeamSmallLnd Successful Response
     * @throws ApiError
     */
    public static getTeamIdByLndLndTeamIdLeagueIdLndIdGet(
        lndId: number,
        leagueId: number,
    ): CancelablePromise<Array<TeamSmallLnd>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/team/id/{league_id}/{lnd_id}',
            path: {
                'lnd_id': lndId,
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Teams By League
     * @param leagueId
     * @returns TeamSmallLnd Successful Response
     * @throws ApiError
     */
    public static getTeamsByLeagueLndTeamsLeagueLeagueIdGet(
        leagueId: number,
    ): CancelablePromise<Array<TeamSmallLnd>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/teams/league/{league_id}',
            path: {
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Create Team
     * @param requestBody
     * @returns TeamSmallLnd Successful Response
     * @throws ApiError
     */
    public static createTeamLndTeamPost(
        requestBody: TeamCreate,
    ): CancelablePromise<TeamSmallLnd> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/lnd/team',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Teams By League Id And Name
     * @param leagueId
     * @param name
     * @returns TeamSmallLnd Successful Response
     * @throws ApiError
     */
    public static getTeamsByLeagueIdAndNameLndTeamsNameLeagueIdNameGet(
        leagueId: number,
        name: string,
    ): CancelablePromise<Array<TeamSmallLnd>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/teams/name/{league_id}/{name}',
            path: {
                'league_id': leagueId,
                'name': name,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Teams By Lnd Id
     * @param lndId
     * @returns TeamSmallLnd Successful Response
     * @throws ApiError
     */
    public static getTeamsByLndIdLndTeamsLndIdGet(
        lndId: number,
    ): CancelablePromise<Array<TeamSmallLnd>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/teams/{lnd_id}',
            path: {
                'lnd_id': lndId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Lnd
     * @param teamId
     * @param lndPrimaryId
     * @param lndSecondaryId
     * @returns any Successful Response
     * @throws ApiError
     */
    public static setLndLndTeamTeamIdLndIdCampionatoPut(
        teamId: number,
        lndPrimaryId: number,
        lndSecondaryId: number,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/lnd/team/{team_id}/{lnd_id}/{campionato}',
            path: {
                'team_id': teamId,
            },
            query: {
                'lnd_primary_id': lndPrimaryId,
                'lnd_secondary_id': lndSecondaryId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Lndable Teams
     * @param leagueId
     * @returns TeamSmallLnd Successful Response
     * @throws ApiError
     */
    public static getLndableTeamsLndLndableLeagueIdGet(
        leagueId: number,
    ): CancelablePromise<Array<TeamSmallLnd>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/lndable/{league_id}',
            path: {
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Match By League Team Date
     * @param leagueId
     * @param teamId
     * @param date
     * @returns MatchLnd Successful Response
     * @throws ApiError
     */
    public static getMatchByLeagueTeamDateLndMatchLeagueLeagueIdTeamTeamIdDateDateGet(
        leagueId: number,
        teamId: number,
        date: string,
    ): CancelablePromise<Array<MatchLnd>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/match/league/{league_id}/team/{team_id}/date/{date}',
            path: {
                'league_id': leagueId,
                'team_id': teamId,
                'date': date,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Lnd Match
     * @param team1LndId
     * @param team2LndId
     * @param leagueId
     * @returns MatchLnd Successful Response
     * @throws ApiError
     */
    public static getLndMatchLndMatchTeam1LndIdTeam2LndIdLeagueIdGet(
        team1LndId: number,
        team2LndId: number,
        leagueId: number,
    ): CancelablePromise<Array<MatchLnd>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/match/{team_1_lnd_id}/{team_2_lnd_id}/{league_id}',
            path: {
                'team_1_lnd_id': team1LndId,
                'team_2_lnd_id': team2LndId,
                'league_id': leagueId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Areas Of Interest By Lnd Id
     * @param lndId
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getAreasOfInterestByLndIdLndAreasOfInterestLndIdGet(
        lndId: string,
    ): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/areas_of_interest/{lnd_id}',
            path: {
                'lnd_id': lndId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Fixed Team Name
     * @param teamName
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getFixedTeamNameLndFixedTeamNameTeamNameGet(
        teamName: string,
    ): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/fixed_team_name/{team_name}',
            path: {
                'team_name': teamName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Set Match Termination Type
     * @param matchId
     * @param matchTerminationType
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static setMatchTerminationTypeLndSetMatchTerminationTypeMatchIdPost(
        matchId: number,
        matchTerminationType?: (string | null),
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/lnd/set_match_termination_type/{match_id}',
            path: {
                'match_id': matchId,
            },
            query: {
                'match_termination_type': matchTerminationType,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Decide League Category
     * @param leagueName
     * @returns LeagueCategoryDecisionResponse Successful Response
     * @throws ApiError
     */
    public static decideLeagueCategoryLndDecideLeagueCategoryLeagueNamePost(
        leagueName: string,
    ): CancelablePromise<LeagueCategoryDecisionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/lnd/decide_league_category/{league_name}',
            path: {
                'league_name': leagueName,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get Leagues Of Team
     * @param teamId
     * @returns string Successful Response
     * @throws ApiError
     */
    public static getLeaguesOfTeamLndLeaguesOfTeamTeamIdGet(
        teamId: number,
    ): CancelablePromise<Array<string>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/leagues_of_team/{team_id}',
            path: {
                'team_id': teamId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Is Team In League
     * @param societa
     * @param comitato
     * @param lndShort
     * @param girone
     * @returns boolean Successful Response
     * @throws ApiError
     */
    public static isTeamInLeagueLndIsTeamSocietaInLeagueComitatoLndShortGironeGet(
        societa: number,
        comitato: number,
        lndShort: string,
        girone: string,
    ): CancelablePromise<boolean> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/is_team/{societa}/in_league/{comitato}/{lnd_short}/{girone}',
            path: {
                'societa': societa,
                'comitato': comitato,
                'lnd_short': lndShort,
                'girone': girone,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * Get All Lnd Ids
     * @returns number Successful Response
     * @throws ApiError
     */
    public static getAllLndIdsLndAllLndIdsGet(): CancelablePromise<Array<number>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/lnd/all_lnd_ids',
        });
    }
}
